import type { ReactElement, RefObject } from "react";

import { Pager } from "./pager.js";
import type { CenterTenant } from "./tenant-types.js";
import { adminCenterUrls } from "./urls.js";

/**
 * 利用者の一覧のページ送り（50 名ずつ。<b>何名ずつか・何ページあるかはサーバが決める</b>）。
 *
 * <b>絞り込み（語・状態）と並び順は残す。</b>見た目と動き（一覧の先頭へ合わせる）は共通の <c>Pager</c>。
 */
export function UserPager({ tenant, top }: {
    readonly tenant: CenterTenant;
    readonly top: RefObject<HTMLElement | null>;
}): ReactElement | null {
    return (
        <Pager
            page={tenant.userPage}
            pageCount={tenant.userPageCount}
            hasNext={tenant.usersFilled}
            total={`全 ${String(tenant.matchingUserCount)} 名`}
            hrefOf={(page) => adminCenterUrls.tenant(tenant.tenantId, {
                userKeyword: tenant.userKeyword, userStatus: tenant.userStatus, userSort: tenant.userSort, userPage: page,
            })}
            top={top}
            marker={{ "data-user-pager": "" }}
        />
    );
}
